const main_menu = [
  {
    id: 0,
    title: "Главная",
    page: 0,
    active: true,
    visible: true,
    header: "тест на определение IQ",
  },
  {
    id: 1,
    title: "Информация о тесте",
    page: 1,
    active: false,
    visible: true,
    header: "тест на определение IQ",
  },
  {
    id: 2,
    title: "Пройти тест",
    page: 2,
    active: false,
    visible: true,
    header: "тест на определение IQ",
  },
  {
    id: 3,
    title: "modal menu",
    page: 3,
    active: false,
    visible: false,
    header: "тест на определение IQ",
  },
  {
    id: 4,
    title: "finish page!",
    page: 4,
    active: false,
    visible: false,
    header: "готово!",
  },
];

export default main_menu;
